import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import QuoteInformationCard from '../../components/QuoteReviewComponents/QuoteInformationCard/QuoteInformationCard';
import InformationCard from '../../components/QuoteReviewComponents/InformationCard/InformationCard';
import AddDocumentsCard from '../../components/QuoteReviewComponents/AddDocumentsCard';
import {
  ChatBubbleLeftEllipsisIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/24/outline';

const BidReviewScreen = ({ handleTabChange }) => {
  const { quoteNo } = useParams();
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="flex flex-col flex-grow max-w-screen">
      <div className="flex">
        <div className="flex flex-col flex-grow overflow-y-auto">
          <div className=" pb-7 space-y-3">
            <div className="flex flex-row w-full space-x-3">
              <img
                alt="Logo"
                src="/Rectangle_107.png"
                className="rounded-lg w-96 h-[267px]"
              />
              <div className="w-full flex-grow">
                <QuoteInformationCard
                  type={'quoteInformation'}
                  quoteNo={quoteNo}
                  supplierReviewScreen={true}
                />
              </div>
            </div>
            <InformationCard
              type={'processAndFinish'}
              supplierReviewScreen={true}
            />
            <InformationCard
              type={'verificationAndValidation'}
              supplierReviewScreen={true}
            />
            <InformationCard type={'logistic'} supplierReviewScreen={true} />
            <AddDocumentsCard />
            <div className="min-w-screen flex-grow overflow-x-auto">
              <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl h-full">
                <div
                  className="flex justify-between hover:cursor-pointer"
                  onClick={() => setCollapsed(!collapsed)}
                >
                  <h5 className="text-2xl tracking-tight text-gray-900 text-[25px]">
                    Project Discription
                  </h5>
                  <div className="flex flex-row space-x-3">
                    <ChatBubbleLeftEllipsisIcon className="h-6 w-6 hover:cursor-pointer" />
                    <button
                      className="block h-6 w-6 hover:cursor-pointer"
                      aria-hidden="true"
                      onClick={() => setCollapsed(!collapsed)}
                    >
                      {!collapsed ? (
                        <ChevronUpIcon className="h-6 w-6" />
                      ) : (
                        <ChevronDownIcon className="h-6 w-6" />
                      )}
                    </button>
                  </div>
                </div>
                {!collapsed && (
                  <div className="mt-6 bg-[#E5E5E5] block rounded-md py-3 px-5 text-gray-900 sm:text-sm sm:leading-6 flex-grow">
                    <div className="text-wrap">
                      <p>
                        {' '}
                        New Yorkers are facing the winter chill with less warmth
                        this year as the city's most revered soup stand
                        unexpectedly shutters, following a series of events that
                        have left the community puzzled. New Yorkers are facing
                        the winter chill with less warmth this year as the
                        city's most revered soup stand unexpectedly shutters,
                        following a series of events that have left the
                        community puzzled
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <InformationCard type={'NDA'} supplierReviewScreen={true} />
            <div className="flex flex-row items-center justify-center space-x-4">
              <button className="rounded-full px-8 py-2 text-[18px] text-left my-1 border-[1px] border-black">
                Cancel
              </button>
              <button
                className="rounded-full px-8 py-2 text-[18px] text-left my-1 bg-gradient-to-r from-[#8B5CF6] to-[#60A5FA] text-white"
                onClick={() => handleTabChange('submit_bid_quote')}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BidReviewScreen;
